<template>
  <kst-table paginated view-mode
    :action="hasAccessAction"
    :data="dataList"
  >
    <b-table-column sortable
      v-slot="{ column, row }"
      field="ConvNumber"
      :label="Catalog.ConvNumber.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column centered sortable
      v-slot="{ column, row }"
      cell-class="ks-col-shortdate"
      field="Date"
      :label="Catalog.Date.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ column, row }"
      field="WarehouseID"
      :label="Catalog.WarehouseID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <template #action="{ row }">
      <Action :access="access" :row="row"/>
    </template>
  </kst-table>
</template>

<script>
import Catalog from "../StcvCatalog.js";

import Action from "./StcvL_List_Action.vue";

export default {
  components: {
    Action
  },
  props: {
    access: Object,
    dataList: Array
  },
  data: () => ({
    Catalog: Catalog
  }),
  computed: {
    hasAccessAction() {
      return this.access.Act_Details ||
        this.access.Act_ExportDetails ||
        this.access.Act_PrintDetails;
    }
  }
}
</script>